
function createMap(scheduleRequestWeekdays) {
  var schedule =  {
    'mon': null,
    'tue': null,
    'wed': null,
    'thu': null,
    'fri': null,
  };

  for (const weekdayObj of scheduleRequestWeekdays) {
    if (weekdayObj.is_pickup) {
      if (weekdayObj.is_dropoff) {
        schedule[weekdayObj.weekday] = 'B';
      }
      else {
        schedule[weekdayObj.weekday] = 'I';
      }
    }
    else {
      if (weekdayObj.is_dropoff) {
        schedule[weekdayObj.weekday] = 'O';
      }
      else {
        // do nothing
      }
    }
  }

  return schedule;
}

function mapDiffObject(diffObj) {
  return diffObj?._diff?.__type
}

export default {
  createMap,
  mapDiffObject,
};
